var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{attrs:{"type":_vm.field.configuration.time ? 'datetime' : 'date',"placeholder":_vm.field.configuration.placeholder,"picker-options":_vm.datePickerOptions,"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }